import { FC } from "react";
import { useTranslation } from "react-i18next";

import { GoToTariffOverviewTile } from "@/apps/partner/components/GoToTariffOverviewTile/GoToTariffOverviewTile";
import { CardGrid } from "@/components/Layout/BaseLayouts/CardGrid/CardGrid";
import { AddDeviceTile } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/AddDeviceTile/AddDeviceTile";
import { PortalHeading } from "@/components/Portal/components/PortalHeading/PortalHeading";

export const PartnerPortal: FC = () => {
  const { t } = useTranslation(["partnerPortal"], {
    keyPrefix: "cockpit.heading",
  });

  return (
    <div className="flex flex-col gap-6 pb-8">
      <PortalHeading variant="cockpit" heading={t("greeting")}>
        <div className="mt-6 flex flex-col gap-4">
          <p className="text-body-lg text-foreground-primary">
            {t("description1")}
          </p>
          <p className="text-body-lg text-foreground-primary">
            {t("description2")}
          </p>
        </div>
      </PortalHeading>

      <CardGrid>
        <AddDeviceTile addDeviceRoute="/partner/add-sim" />
        <GoToTariffOverviewTile />
      </CardGrid>
    </div>
  );
};
